import * as Yup from 'yup';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature new-import
import * as C from '../constants';
//////////////////////////////////////////////////

const inputWrapperStyles = {
  mb: 25,
  width: 300,
};

export const booleanOptions = [
  {
    [GC.FIELD_VALUE]: true,
    [GC.FIELD_LABEL]: 'Yes',
  },
  {
    [GC.FIELD_LABEL]: 'No',
    [GC.FIELD_VALUE]: false,
  },
];

export const matchFields = (field) => (
  {
    type: 'select',
    fieldName: field,
    options: 'matchedOptions',
    inputWrapperStyles: { width: 200 },
    shouldCustomChange: G.ifElse(R.includes('.', field), true, false),
  }
);

export const importTypes = [
  {
    value: C.IMPORT_TYPE_DRIVER,
    label: G.getWindowLocale('titles:driver', 'Driver'),
  },
  {
    value: C.IMPORT_TYPE_TRUCK,
    label: G.getWindowLocale('titles:truck', 'Truck'),
  },
  {
    value: C.IMPORT_TYPE_TRAILER,
    label: G.getWindowLocale('titles:trailer', 'Trailer'),
  },
  {
    value: C.IMPORT_TYPE_TRAILER_ACTIVITY_LIST_TRAILER,
    label: G.getWindowLocale('titles:trailer-activity', 'Trailer Activity'),
  },
  {
    value: C.IMPORT_TYPE_TOLL_CHARGE,
    label: G.getWindowLocale('titles:toll-charge', 'Toll Charge'),
  },
  {
    value: C.IMPORT_TYPE_FUEL_CARD_TRANSACTION,
    label: G.getWindowLocale('titles:fuel-transactions', 'Fuel Transactions'),
  },
  {
    value: C.IMPORT_TYPE_LOCATION,
    label: G.getWindowLocale('titles:location', 'Location'),
  },
  {
    value: C.IMPORT_TYPE_CONTACT_BOOK,
    label: G.getWindowLocale('titles:contact', 'Contact'),
  },
  {
    value: C.IMPORT_TYPE_BRANCH,
    label: G.getWindowLocale('titles:branch', 'Branch'),
  },
  {
    value: C.IMPORT_TYPE_CARRIER,
    label: G.getWindowLocale('titles:carrier', 'Carrier'),
  },
  {
    value: C.IMPORT_TYPE_CARRIER_INVOICE,
    label: G.getWindowLocale('titles:carrier-invoice', 'Carrier Invoice'),
  },
  {
    value: C.IMPORT_TYPE_CARRIER_INSURANCE,
    label: G.getWindowLocale('titles:carrier-insurance', 'Carrier Insurance'),
  },
  {
    value: C.IMPORT_TYPE_CARRIER_PAY_TO_LOCATION,
    label: G.getWindowLocale('titles:carrier-pay-to-location', 'Carrier Pay To Location'),
  },
  {
    value: C.IMPORT_TYPE_GEO_FENCING_ZONE,
    label: G.getWindowLocale('titles:geo-fencing-zone', 'Geo Fencing Zone'),
  },
  {
    value: C.IMPORT_TYPE_GEOFENCING_LOCATION,
    label: G.getWindowLocale('titles:geo-fencing-location', 'Geo Fencing Location'),
  },
  {
    value: C.IMPORT_TYPE_CLO,
    label: G.getWindowLocale('titles:clo', 'CLO'),
  },
  {
    value: C.IMPORT_TYPE_COMPENSATION_GROUP,
    label: G.getWindowLocale('titles:compensation-group', 'Compensation Group'),
  },
];

export const importStatusesTypes = [
  {
    value: GC.STATUS_FAILED,
    label: G.getWindowLocale('titles:failed', 'Failed'),
  },
  {
    value: GC.STATUS_PENDING,
    label: G.getWindowLocale('enum:pending', 'Pending'),
  },
  {
    value: GC.STATUS_SUCCESS,
    label: G.getWindowLocale('titles:success', 'Success'),
  },
  {
    value: GC.STATUS_IN_PROGRESS,
    label: G.getWindowLocale('titles:in-progress', 'In Progress'),
  },
  {
    value: GC.STATUS_PARTIAL_SUCCESS,
    label: G.getWindowLocale('titles:partial-success', 'Partial Success'),
  },
];

const importTypeCarrierRatePrice = {
  value: C.IMPORT_TYPE_CARRIER_RATE_PRICE,
  label: G.getWindowLocale('titles:carrier-rate-price', 'Carrier Rate Price'),
};

const importTypeCarrierAwardedLine = {
  value: C.IMPORT_TYPE_CARRIER_AWARDED_LINE,
  label: G.getWindowLocale('titles:carrier-contract-awarded-line', 'Carrier Contract Awarded Line'),
};

const importTypeCustomerAwardedLine = {
  value: C.IMPORT_TYPE_CUSTOMER_AWARDED_LINE,
  label: G.getWindowLocale('titles:customer-contract-awarded-line', 'Customer Contract Awarded Line'),
};

export const importTypesWithCarrierRatePrice = R.concat(importTypes, [
  importTypeCarrierRatePrice,
  importTypeCarrierAwardedLine,
  importTypeCustomerAwardedLine,
]);

export const tollChargeSourceOptions = [
  {
    label: 'I-Pass',
    value: GC.FLEET_INTEGRATION_TYPE_I_PASS,
  },
  {
    label: 'Bestpass',
    value: GC.FLEET_INTEGRATION_TYPE_BESTPASS,
  },
  {
    label: 'PrePass',
    value: GC.FLEET_INTEGRATION_TYPE_PRE_PASS,
  },
  {
    label: 'Self Toll',
    value: GC.FLEET_INTEGRATION_TYPE_SELF_TOLL,
  },
];

export const fuelCardTransactionSourceOptions = [
  {
    label: 'BVD Group',
    value: GC.FUEL_CARDS_TYPE_BVD,
  },
  {
    label: 'Comdata',
    value: GC.FUEL_CARDS_TYPE_COMDATA,
  },
  {
    label: 'Compass',
    value: GC.FUEL_CARDS_TYPE_COMPASS,
  },
  {
    value: GC.FUEL_CARDS_TYPE_EFS,
    label: G.getWindowLocale('titles:efs', 'EFS'),
  },
  {
    label: 'Relay',
    value: GC.FUEL_CARDS_TYPE_RELAY,
  },
  {
    value: GC.FUEL_CARDS_TYPE_SELF_FUELED,
    label: G.getWindowLocale('titles:self-fueled', 'Self Fueled'),
  },
  {
    value: GC.FUEL_CARDS_TYPE_QUIKQ,
    label: G.getWindowLocale('titles:quikq', 'QUIKQ'),
  },
];

export const addRowsField = {
  type: 'number',
  fieldName: 'count',
  label: ['titles:number-of-rows'],
  inputWrapperStyles: { mb: 15, width: 200 },
};

export const importFileField = {
  type: 'file',
  inputWrapperStyles,
  label: ['titles:upload-file'],
  fieldName: GC.FIELD_DOCUMENT_UPLOAD,
};

export const importTypeField = {
  type: 'select',
  options: importTypes,
  fieldName: GC.FIELD_TYPE,
  shouldCustomChange: true,
  label: ['titles:import-type'],
  inputWrapperStyles: {
    width: 300,
  },
};

export const importTypeSchema = {
  [GC.FIELD_TYPE]: Yup.string().required(G.getRequiredLocaleTxt()),
};

export const defaultImportFromFileFields = {
  [GC.FIELD_SOURCE]: '',
  [GC.FIELD_ROLE_ROLES_GUIDS]: [],
  [GC.FIELD_DOCUMENT_UPLOAD]: null,
  [GC.FIELD_TYPE]: C.IMPORT_TYPE_DRIVER,
};

export const importFromFileFieldSettings = [
  {
    ...importTypeField,
    customChangeHandler: (event, _, { values, setValues }) => {
      setValues(R.mergeRight(
        values,
        {
          [GC.FIELD_SOURCE]: null,
          [GC.FIELD_TYPE]: G.getEventTargetValue(event),
        },
      ));
    },
    inputWrapperStyles: {
      ...inputWrapperStyles,
      display: (props) => G.ifElse(
        R.includes(R.path(['values', GC.FIELD_TYPE], props), C.CONTRACT_IMPORT_TYPES),
        'none',
        'block',
      ),
    },
  },
  {
    type: 'reactSelect',
    label: ['titles:source'],
    options: 'sourceOptions',
    fieldName: GC.FIELD_SOURCE,
    inputWrapperStyles: {
      ...inputWrapperStyles,
      display: (props) => G.ifElse(
        R.includes(
          R.path(['values', GC.FIELD_TYPE], props),
          [C.IMPORT_TYPE_TOLL_CHARGE, C.IMPORT_TYPE_FUEL_CARD_TRANSACTION],
        ),
        'flex',
        'none',
      ),
    },
  },
  {
    isMulti: true,
    type: 'reactSelect',
    label: ['titles:roles'],
    options: 'driverRoleOptions',
    fieldName: GC.FIELD_ROLE_ROLES_GUIDS,
    inputWrapperStyles: {
      ...inputWrapperStyles,
      display: (props) => G.ifElse(
        R.pathEq(C.IMPORT_TYPE_DRIVER, ['values', GC.FIELD_TYPE], props),
        'flex',
        'none',
      ),
    },
  },
  {
    type: 'toggle',
    fieldName: 'replaceExistentCompensations',
    label: ['titles:replace-existent-compensations'],
    inputWrapperStyles: {
      ...inputWrapperStyles,
      display: (props) => G.ifElse(
        R.pathEq(C.IMPORT_TYPE_COMPENSATION_GROUP, ['values', GC.FIELD_TYPE], props),
        'flex',
        'none',
      ),
    },
  },
  importFileField,
];

export const importFromFileValidationSchema = Yup.object().shape({
  [GC.FIELD_DOCUMENT_UPLOAD]: Yup.string().required(G.getRequiredLocaleTxt()),
});

export const sequenceTemplateIdField = {
  type: 'text',
  label: ['titles:template-id'],
  fieldName: GC.FIELD_TEMPLATE_ID,
  inputWrapperStyles: { mb: 15, width: 200 },
};

export const additionalField = (label) => ({
  type: 'text',
  label: [label],
  width: '200px',
  inputsWidth: '100%',
  fieldName: GC.FIELD_VALUE,
  inputWrapperStyles: { mb: 15, width: 200 },
});

export const importCLOFromFileFields = [
  importFileField,
  {
    type: 'select',
    inputWrapperStyles,
    fieldName: 'mapper',
    label: ['titles:mapper'],
    options: 'mapperOptions',
  },
];
